import React from 'react';
import ReactDOM from 'react-dom';
import './components/index.css';
import App from './components/App';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js